import Promise from 'bluebird';
import $ from 'jquery';
import _ from 'underscore';

export type AjaxXhr = ReturnType<typeof $.ajax> | null;

export type AjaxTextStatus = string;

export type AjaxErrorThrown = string | undefined;

export type AjaxSuccessCallback = (
  data: unknown,
  status: AjaxTextStatus,
  inputData: unknown,
  onSuccessEventData: unknown,
  xhr: AjaxXhr
) => void;

export type AjaxErrorCallback = (
  xhr: AjaxXhr,
  textStatus: AjaxTextStatus,
  errorThrown: AjaxErrorThrown
) => void;

export type AjaxRedirectHandler = (
  redirectUrl: string,
  message: unknown,
  data: unknown
) => void;

export interface AjaxRequestOptions {
  onSuccess?: AjaxSuccessCallback;
  onAjaxError?: AjaxErrorCallback;
  redirectHandler?: AjaxRedirectHandler;
  [key: string]: unknown;
}

export type AjaxRequestFunction = (options: AjaxRequestOptions) => void;

export class AjaxError extends Error {
  errorThrown: AjaxErrorThrown;
  textStatus: AjaxTextStatus;
  xhr: AjaxXhr;
  constructor(xhr: AjaxXhr, textStatus: AjaxTextStatus, errorThrown: AjaxErrorThrown) {
    super(errorThrown);
    this.name = 'AjaxError';
    this.xhr = xhr;
    this.textStatus = textStatus;
    this.errorThrown = errorThrown;
  }
}

export class JsonError extends Error {
  data: unknown;
  status: AjaxTextStatus;
  xhr: AjaxXhr;
  constructor(data: unknown, status: AjaxTextStatus, xhr: AjaxXhr) {
    super();
    this.name = 'JsonError';
    this.data = data;
    this.status = status;
    this.xhr = xhr;
  }
}

function generateSuccessAndFail(
  options: AjaxRequestOptions,
  resolve: (value: unknown) => void,
  reject: (reason?: unknown) => void
) {
  const prevOnSuccess = $.isFunction(options.onSuccess) ? options.onSuccess : _.noop;
  const prevOnAjaxError = $.isFunction(options.onAjaxError) ? options.onAjaxError : _.noop;

  return _.extend(options, {
    onSuccess: (data: unknown, status: AjaxTextStatus, inputData: unknown, onSuccessEventData: unknown, xhr: AjaxXhr) => {
      prevOnSuccess(data, status, inputData, onSuccessEventData, xhr);
      $.advertiser.ajaxSuccess(
        data,
        status,
        xhr,
        () => resolve(data),
        () => reject(new JsonError(data, status, xhr)),
        options.redirectHandler
      );
    },
    onAjaxError: (xhr: AjaxXhr, textStatus: AjaxTextStatus, errorThrown: AjaxErrorThrown) => {
      prevOnAjaxError(xhr, textStatus, errorThrown);
      reject(new AjaxError(xhr, textStatus, errorThrown));
    },
  });
}

function createPromise(requestFunction: AjaxRequestFunction, options: AjaxRequestOptions) {
  return new Promise<unknown>((resolve, reject) => {
    requestFunction(generateSuccessAndFail(options, resolve, reject));
  });
}

export function post(options: AjaxRequestOptions) {
  return createPromise($.advertiser.ajaxPost, options);
}

export function get(options: AjaxRequestOptions) {
  return createPromise($.advertiser.ajaxGet, options);
}

export function patch(options: AjaxRequestOptions) {
  return createPromise($.advertiser.ajaxPatch, options);
}
